interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div className={`mb-6 md:mb-8 ${align === "center" ? "text-center" : ""}`}>
      {kicker && (
        <p className="mb-2 flex items-center gap-2 text-sm font-medium uppercase tracking-wider text-accent-600">
          <span className="inline-block h-px w-6 bg-accent-400" />
          {kicker}
        </p>
      )}
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {description && (
        <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${align === "center" ? "mx-auto" : ""}`}>
          {description}
        </p>
      )}
    </div>
  );
}